import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { NavigationService } from '../services/navigation.service';
import { StorageItems } from '../constants/storage-items.constants';
import { collection, FBaseService } from '../services/firebase/f-base.service';

export const PrivacypolicyGuard = async () => {
  const authService = inject(AuthService);
  const fbService = inject(FBaseService);
  const router = inject(Router);
  const navigationService = inject(NavigationService);

  try {
    const firebaseUser = await firstValueFrom(authService.currentUserObservable());

    if (!firebaseUser || !firebaseUser.uid) {
      localStorage.removeItem(StorageItems.USERID);
      navigationService.navigateRootInstant('login');
      return false;
    }

    const user = await firstValueFrom(fbService.getById(collection.users, firebaseUser.uid)) as any;
    if (!user) {
      try {
        await authService.logout();
      } catch (logoutError) {
        console.error('Orphan cleanup logout error:', logoutError);
      }
      localStorage.removeItem(StorageItems.USERID);
      navigationService.navigateRootInstant('login');
      return false;
    }

    localStorage.setItem(StorageItems.USERID, firebaseUser.uid);

    if (user.privacyPolicyAccepted) {
      navigationService.navigateRootInstant('home');
      return false;
    }

    return true;

  } catch (error) {
    console.error('Authentication error:', error);
    localStorage.removeItem(StorageItems.USERID);
    return router.parseUrl('login');
  }
};
